import React from 'react';
import TextAsHTML from '../../../components/_base/TextAsHTML';
import { EventPrivateSettingsType } from '../../../lib/context-providers/event-settings-context/event-settings-context';
import KnovioThumbnail from './KnovioThumbnail';
import WelcomeFooter from './WelcomeFooter';
import { EventPrivateDetailsResponseType } from '../../../lib/api';
import useEventCalendar from '../../../hooks/use-event-calendar';
import Buttons from '../../../components/button';
import './WelcomeBlock.scss';
import useEventToken from '../../../hooks/use-event-token';
import QRCode from 'qrcode.react';
import { useCurrentUserInfo } from '../../..//hooks/api/protected/use-current-user-info';


const WelcomeBlock = (props: EventPrivateDetailsResponseType & EventPrivateSettingsType): JSX.Element => {
  const {
    name,
    eventId,
    welcomeLabel,
    privateDescription,
    welcomeKnovioEnabled,
    welcomeKnovioEmbedId,
    calendarButtonEnabled,
    eventTitleForPassport
  } = props;

  const token = useEventToken(eventId);
  const { fetchOutlookCalendarForEvent, fetchGoogleCalendarForEvent } = useEventCalendar();

  const getEventTitle = (customTitle: string | undefined, defaultTitle: string): string => {
    return customTitle ? customTitle : defaultTitle;
  };
  const fileName = `${getEventTitle(eventTitleForPassport, name)}.ics`;

  const blockClassName = 'overflow-hidden shadow-gray bg-white mx-auto md:w-3/4 mt-12 max-h-full ' +
    'h-full w-100 mx-0 min-h-24rem flex flex-col justify-between';
  const className = 'editable-welcome';
  const classNameWelcomeWrapper = `${className}--wrapper`;
  const classNameWelcomeDescription = `${className}--description`;
  const classNameWelcomeTitle = `${className}--title`;

  const { data } = useCurrentUserInfo();

  //console.log('data:',data?.attendanceMethod);

  return (
    <div className={`${classNameWelcomeWrapper} ${blockClassName}`}>
      <div>
        <h1 className={`${classNameWelcomeTitle} font-size-40px`}>{welcomeLabel}</h1>
        <hr />
        {welcomeKnovioEnabled && welcomeKnovioEmbedId && <KnovioThumbnail welcomeKnovioEmbedId={welcomeKnovioEmbedId} />}
        <div className={`${classNameWelcomeDescription} truncate-advanced-15`}>
          <TextAsHTML formattedText={privateDescription} />
        </div>
        {data && data.attendanceMethod === 'IN_PERSON' &&
          <div>
            <p>Thank you for registering for ANTA Sports Products Limited's Annual Results Presentation event in Hong Kong on 26 Mar. You will be required to <strong>present the QR code</strong> below and your name card <strong>upon admission</strong>. Visitors that failed to present the QR code upon admistion might be denied entry.</p>
            <p>感謝閣下報名參加安踏體育用品有限公司於3月26日在香港舉行的2023年度業績發佈會。這是活動的報名確認通知，請於活動當天<strong>入場時出示確認二維碼</strong>及閣下之名片，以便安排進場。未能出示確認二維碼之參加者有可能被拒進入會場，敬請留意。</p>
            <table>
              <tbody>
                <tr>
                  <td>
                    <strong>Date 日期：</strong>
                  </td>
                  <td>
                    <p>26 March 2024 (Tuesday)</p>
                    <p>2024年3月26日 (星期二)</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Time 時間：</strong>
                  </td>
                  <td>
                    <p>3:00 p.m. - 4:00 p.m. (HKT 香港時間)</p>
                    <p>(investor registartion at 2:45 p.m. 下午2時45分開始接受登記)</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Venue 場地：</strong>
                  </td>
                  <td>
                    <p>Ballroom, Level 3, JW Marriot Hotel Hong Kong</p>
                    <p>Pacific Place, 88 Queensway, Hong Kong</p>
                    <p>香港JW萬豪酒店3樓宴會廳</p>
                    <p>香港金鐘道88號太古廣場</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Language 語言：</strong>
                  </td>
                  <td>
                    <p>Mandarin (simultaneous interpretation will be provided)</p>
                    <p>普通話 (設有英語同聲傳譯)</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>Should there be any queries, please feel free to contact Citigate Dewe Rogerson at <a href="mailto:AntaSportsIR@citigatedewerogerson.com" target="_blank">AntaSportsIR@citigatedewerogerson.com</a>.</p>
            <p>如有任何查詢，請聯繫哲基傑訊 <a href="mailto:AntaSportsIR@citigatedewerogerson.com" target="_blank">AntaSportsIR@citigatedewerogerson.com</a>。</p>
            <QRCode value={ 'https://oespring242.nasthon.com/checkin/scan/'+data.attendeeId.toString() } size={1024} />
            <p>Please present the above QR code above upon admission</p>
            <p>請於活動當天入場時出示此確認二維碼</p>
          </div>
        }
        {data && data.attendanceMethod === 'VIRTUAL' &&
          <div>
            <p>Thank you for registering for ANTA Sports Products Limited's 2023 Annual Results Presentation <strong>live webcast</strong>.</p>
            <p>感謝閣下報名參加安踏體育用品有限公司於3月26日舉行的2023年度業績線上發佈會。</p>
            <table>
              <tbody>
                <tr>
                  <td>
                    <strong>Date 日期：</strong>
                  </td>
                  <td>
                    <p>26 March 2024 (Tuesday)</p>
                    <p>2024年3月26日 (星期二)</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Time 時間：</strong>
                  </td>
                  <td>
                    <p>3:00 p.m. - 4:00 p.m. (HKT 香港時間)</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Language 語言：</strong>
                  </td>
                  <td>
                    <p>Mandarin (simultaneous interpretation will be provided)</p>
                    <p>普通話 (設有英語同聲傳譯)</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <a href="https://anta-annual-results-2023.open-exchange.net/webinar">Webinar 線上直播</a>
            <p>Please select your preferred language after log-in. We highly recommend participants to use headphones instead of a speaker when joining the investor presentation to ensure better audio quality.</p>
            <p>請在登入後選擇語言。我們建議與會者使用耳機觀看視頻直播，以確保更好的音頻質量。</p>
            <p>Should there be any queries, please feel free to contact Citigate Dewe Rogerson at <a href="mailto:AntaSportsIR@citigatedewerogerson.com" target="_blank">AntaSportsIR@citigatedewerogerson.com</a>.</p>
            <p>如有任何查詢，請聯繫哲基傑訊 <a href="mailto:AntaSportsIR@citigatedewerogerson.com" target="_blank">AntaSportsIR@citigatedewerogerson.com</a>。</p>
          </div>
        }
        {calendarButtonEnabled &&
          <div className='add-to-calendar-btn--wrapper my-6 ml-5'>
            <Buttons.OptionsButton
              label={`Add to Calendar`}
              name={'addToCalendar'}
              disabled={false}
              eventId={eventId.toString() || ''}
              eventName={name || ''}
              className='connect-to-meeting-btn rounded bg-primary text-white on-hover-shadow flex'
              downloadIcsFile={async () => fetchOutlookCalendarForEvent(eventId.toString() || '', fileName, token)}
              openGoogleCalendar={async () => fetchGoogleCalendarForEvent(eventId.toString() || '', false, token)}
              withCalendarIcon
            />
          </div>
        }
      </div>
      <WelcomeFooter {...props} />
    </div>
  );
};

export default WelcomeBlock;
